export default __webpack_public_path__ + "static/media/LOCKETGO_LOGO_RVB-Noir.26e00731.svg";